import styled from "styled-components";
import {ComponentChildren} from "preact";
import {useEffect, useRef} from "preact/hooks";

const Shadow = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    min-height: 100%;
    transition: all .2s ease-out;
    z-index: 2;
    pointer-events: none;
`

const ShadowLeft = styled(Shadow)`
    box-shadow: 1rem 0 1rem -1rem rgba(0,0,0,0.6) inset;
`;

const ShadowRight = styled(Shadow)`
    box-shadow: -1rem 0 1rem -1rem rgba(0,0,0,0.6) inset;
`;

export const Scrollbox = styled((props: {children: ComponentChildren, className?: string}) => {
    const target = useRef<HTMLDivElement>(null);
    const shadowLeft = useRef<HTMLDivElement>(null);
    const shadowRight = useRef<HTMLDivElement>(null);

    const isScrolling = useRef<boolean>(false);

    const setShadows = () => {
        if (!isScrolling.current) {
            window.requestAnimationFrame(() => {
                if (shadowLeft.current && shadowRight.current && target.current) {
                    shadowLeft.current.style.display = target.current.scrollLeft > 0 ? "" : "none";
                    shadowRight.current.style.display = target.current.scrollLeft < target.current.scrollWidth - target.current.clientWidth ? "" : "none";
                }

                isScrolling.current = false;
            });
            isScrolling.current = true;
        }
    };

    useEffect(() => {
        setShadows();
    }, []);

    return <div onScroll={() => setShadows()} ref={target} className={props.className}>
        <ShadowLeft ref={shadowLeft} />
        <ShadowRight ref={shadowRight} />
        {props.children}
    </div>
})`
    position: relative;
    display: flex;
    overflow: hidden;
    
    > * {
        flex-grow: 1;
        height: 100%;
    }
`;
